<template>
    <div>
        <div class="cardSearsh" >
          <el-form @submit.native.prevent  class="flexBet">
            <el-input v-model.trim="code" maxlength="20" ref="refcode" clearable placeholder="券卡编码 / 序列号"  @keyup.enter.native="getcodeinfoDet"></el-input>
            <span>
              <em :class="{'on':operateIndex==0}" @click="getcodeinfoDet">查询</em>
              <em v-if="ElementControls('checkoldcard')==1" :class="{'on':operateIndex==1}" @click="showCodeForm">老卡验真</em>
            </span>
          </el-form>
        </div>
        <article class="cardArticle" v-if="operateIndex==0">
					<div v-if="vloading" style="margin-top: 400px;" v-loading="vloading"> </div>
            <section class="cardCon" v-if="codeinfo!=''||couponinfo!=''">
                <el-tabs v-model="activeName" type="card" class="cardTab">
                    <el-tab-pane label="券卡信息" name="cardMessage" v-if="codeinfo!=''||couponinfo!=''">
                        <!-- S TODO:类型为礼品券卡时的展示 -->
                        <!-- S 券卡基础信息组件 -->
                        <CardsDetail  :isselfCard="isselfCard" :cardInfo="codeinfo" @openStore="getShowCheckStore" v-if="cardsType == '礼品券卡'"></CardsDetail>
                        <!-- E 券卡基础信息组件 -->
                        <!-- E TODO:类型为礼品券卡时的展示 -->
                        <!-- S TODO:类型为优惠券时的展示 -->
                        <div class="flexAro basicWrap" v-if="cardsType == '优惠券'">
                            <ul>
                                <li>
                                    <em>优惠券编码：</em>
                                    <b>{{couponinfo.code}}<em v-if="couponinfo.serial">【{{couponinfo.serial}}】</em></b>
                                </li>
                                <li>
                                    <em>状态：</em>
                                    <strong class="boldStr blueColor">{{couponinfo.state | yhcardStateFilter}}</strong>
                                </li>
                                <li>
                                    <em>面值：</em>
                                    <b class="priceFont">￥{{couponinfo.facevalue|formatAmount}}</b>
                                </li>
                                <li>
                                    <em>最低消费金额：</em>
                                    <b class="priceFont">￥{{couponinfo.minconamount|formatAmount}}</b>
                                </li>
                                <li class="rulrMemo">
                                    <em>有效期：</em>
                                    <b>
                                       <span v-if="couponinfo.startvaldate==null&&couponinfo.endvaldate==null">长期有效</span>
                                      <span v-if="couponinfo.startvaldate!=null&&couponinfo.endvaldate!=null">{{dateTime(couponinfo.startvaldate)}} ~ {{dateTime(couponinfo.endvaldate)}}</span>
                                      <span v-if="couponinfo.startvaldate!=null&&couponinfo.endvaldate==null">{{dateTime(couponinfo.startvaldate)}}后有效</span>
                                      <span v-if="couponinfo.startvaldate==null&&couponinfo.endvaldate!=null">{{dateTime(couponinfo.endvaldate)}}前有效</span>
                                    </b>
                                </li>
                                <li>
                                    <em>优惠券介质：</em>
                                    <b>{{couponinfo.coumedium?"电子券卡":"实体券卡"}}</b>
                                </li>
                                <li>
                                    <em>类型：</em>
                                    <b :class="couponinfo.coupontype | couponTypeColorFilter">{{couponinfo.coupontype | couponTypeFilter}}</b>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <em>来源：</em>
                                    <b v-if="couponinfo.usedfor==0">总部发放</b>
                                    <b v-if="couponinfo.usedfor==1">商城领券中心</b>
                                    <b v-if="couponinfo.usedfor==2">礼包发放</b>
                                    <b v-if="couponinfo.usedfor==3">积分兑换</b>
                                    <b v-if="couponinfo.usedfor==4">活动奖品</b>
                                    <b v-if="couponinfo.usedfor==5">砍价发放</b>
                                </li>
                                <li>
                                    <em>适用范围：</em>
                                    <b>{{couponinfo.scope==1?"线下门店":'商城通用'}}</b>
                                </li>
                                <li class="rulrMemo">
                                    <em>优惠券简述：</em>
                                    <b>{{couponinfo.sketch ||'--'}}</b>
                                </li>
                                <li class="rulrMemo">
                                    <em>备注：</em>
                                    <b>{{couponinfo.memo ||'--'}}</b>
                                </li>
                               <!-- <li class="rulrMemo">
                                    <em>相关操作时间：</em>
                                    <b>
                                      <span>出库时间：{{dateTime(couponinfo.defdate,1)}}</span>
                                      <span v-if="couponinfo.state==2">使用时间：{{dateTime(couponinfo.upddate,1)}}</span>
                                      <span v-if="couponinfo.state==3">暂停时间：{{dateTime(couponinfo.upddate,1)}}</span>
                                      <span v-if="couponinfo.state==4">回收时间：{{dateTime(couponinfo.upddate,1)}}</span>
                                      <span v-if="couponinfo.state==5">作废时间：{{dateTime(couponinfo.upddate,1)}}</span>
                                      <span v-if="couponinfo.state==8">回收折现时间：{{dateTime(couponinfo.upddate,1)}}</span>
                                    </b>
                                </li>-->
                            </ul>
                        </div>
                        <!-- E TODO:类型为优惠券时的展示 -->
                        <!-- S TODO:类型为消费卡时的展示 -->
                        <div class="flexAro basicWrap" v-if="cardsType == '消费卡'">
                            <ul>
                                <li>
                                    <em>消费卡编码：</em>
                                    <b>{{codeinfo.code}}<em v-if="codeinfo.serial">【{{codeinfo.serial}}】</em></b>
                                </li>
                                <li>
                                      <em>状态：</em>
                                      <strong class="boldStr blueColor">{{codeinfo.state | cardStateFilters}}</strong>
                                </li>
                                <li>
                                    <em>消费卡流向：</em>
                                    <b class="">{{codeinfo.flowname ||'门店直发'}}</b>
                                </li>
                                <li>
                                    <em>消费卡面值：</em>
                                    <b class="priceFont">￥{{codeinfo.cardprice |formatAmount}}</b>
                                </li>
                                <li>
                                    <em>消费卡售价：</em>
                                    <b class="priceFont">￥{{codeinfo.cardsmallprice |formatAmount}}</b>
                                </li>
                               <li v-if="infoszhanghu" class="rulrMemo">
                                  <em>充值账户：</em>
                                  <b>
                                    <i>{{infoszhanghu.nickname ||infoszhanghu.username}}</i>&nbsp;
                                    <i v-if="infoszhanghu.nickname&&infoszhanghu.nickname!=null&&infoszhanghu.username&&infoszhanghu.username!=null">[{{infoszhanghu.username}}]</i>
                                  </b>
                                </li>
                                <li>
                                    <em>宣传动画：</em>
                                    <b>{{codeinfo.name ||'--'}}</b>
                                    <!-- <i class="iconewm" v-popover:aniPop v-if="codeinfo.name"></i>
                                    <el-popover placement="right-start" width="160" trigger="hover" ref="aniPop">
                                        <div class="previewPop">
                                            <a href="javascript:;">
                                                <img class="imgAlign" src="http://presale.jhtsoft.com/presell-goods-consumer/f8137353e2af7.jpg" alt="" title="微信扫码 预览动画">
                                            </a>
                                            <p>微信扫码 预览动画</p>
                                        </div>
                                    </el-popover> -->
                                </li>
                                <li class="rulrMemo">
                                  <em>有效期：</em>
                                  <b>
                                    <span v-if="codeinfo.startvaldate==null&&codeinfo.endvaldate==null">长期有效</span>
                                    <span v-if="codeinfo.startvaldate!=null&&codeinfo.endvaldate!=null">{{dateTime(codeinfo.startvaldate)}} ~ {{dateTime(codeinfo.endvaldate)}}</span>
                                    <span v-if="codeinfo.startvaldate!=null&&codeinfo.endvaldate==null">{{dateTime(codeinfo.startvaldate)}}后有效</span>
                                    <span v-if="codeinfo.startvaldate==null&&codeinfo.endvaldate!=null">{{dateTime(codeinfo.endvaldate)}}前有效</span>
                                  </b>
                              </li>
                                <li>
                                    <em>消费卡介质：</em>
                                    <b>{{codeinfo.cardmedium?'电子券卡':'实体券卡'}}</b>
                                </li>
                            </ul>
                            <ul>
                                <li class="rulrMemo">
                                    <em>备注：</em>
                                    <b>{{codeinfo.memo||'--'}}</b>
                                </li>
                               <!-- <li class="rulrMemo">
                                    <em>相关操作时间：</em>
                                    <b>
                                      <span>出库时间：{{dateTime(codeinfo.foperdate,1)}}</span>
                                      <span v-if="codeinfo.state==2||codeinfo.state==3">使用时间：{{dateTime(codeinfo.upddate,1)}}</span>
                                      <span v-if="codeinfo.state==4">暂停时间：{{dateTime(codeinfo.upddate,1)}}</span>
                                      <span v-if="codeinfo.state==5">回收时间：{{dateTime(codeinfo.upddate,1)}}</span>
                                      <span v-if="codeinfo.state==6">作废时间：{{dateTime(codeinfo.upddate,1)}}</span>
                                      <span v-if="codeinfo.state==8">回收折现时间：{{dateTime(codeinfo.upddate,1)}}</span>
                                    </b>
                                </li>-->
                            </ul>
                        </div>
                        <!-- E TODO:类型为消费卡时的展示 -->
                        <!-- S 会员信息 -->
                     <div class="bannerBg basicWrap" v-if="((codetype==1&&couponinfo.isaddcardbag==1)||(codetype==2&&codeinfo.isaddcardbag==1))&&infos">
                            <p class="bannerTit" v-show="infos.realname&&infos.realname!=null"><b><strong class="textFl realname">{{infos.realname||'--'}}</strong>的卡包会员信息</b></p>
                            <ul>
                                <li class="flexUpDownCenter">
                                    <div class="flexUpDownCenter memberInfo">
                                        <span class="avatarImg"><samp>
                                          <img class="imgAlign" v-if="infos.hpurl&&infos.hpurl!=null" :src="infos.hpurl" onerror="this.src='https://presale.jhtsoft.com/picms/c47499b67d489.png'">
                                          <img class="imgAlign" v-else src="https://presale.jhtsoft.com/picms/c47519dc61feb.png" onerror="this.src='https://presale.jhtsoft.com/picms/c47499b67d489.png'">
                                          </samp></span>
                                        <p>
                                            <strong v-show="infos.nickname&&infos.nickname!=null" class="textFl" :title="infos.nickname||''">{{infos.nickname||'--'}}</strong>
                                            <b v-show="infos.username&&infos.username!=null" class="textFl" :title="infos.username||''">{{infos.username||'--'}}</b>
                                            <span>{{infos.mphone}} <strong v-if="infos.tphone">/</strong> {{infos.tphone}}</span>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                      <!-- E 会员信息 -->
                    </el-tab-pane>
                    <el-tab-pane v-if="(codeinfo!=''&&codeinfo.codetype=='1')||(codeinfo!=''&&codeinfo.codetype=='0')||(couponinfo!='')" label="券卡操作记录" name="cardRecord">
                        <div class="gsListTable individualiz">
                      <el-form inline size="medium">
                        <el-form-item class="borderline borderNone">
                          <el-checkbox v-model="isSearchAll" @change="isallList">查询全部</el-checkbox>
                        </el-form-item>
                      </el-form>
                      <el-table ref="gsTable" class="comTable recordTable" border :data="recordinfoList" :maxHeight="tableHeight">
                          <el-table-column fixed label="序号" type="index"></el-table-column>
                          <el-table-column label="操作类型" min-width="100" sortable prop="opertype">
                              <template slot-scope="scope">
                                  <em class="textHiden" title="test33">{{scope.row.opertype | cardOpertypeFilter(scope.row.opesource,scope.row.cardmedium)}}</em>
                              </template>
                          </el-table-column>
                          <el-table-column label="日期" sortable prop="operdate" min-width="150">
                              <template slot-scope="scope">
                                  {{dateTime(scope.row.operdate,1)}}
                              </template>
                          </el-table-column>
                          <el-table-column label="操作人" sortable prop="operuname" min-width="100">
                              <template slot-scope="scope">
                                  <em class="textHiden" :title="scope.row.operuname">{{scope.row.operuname}}</em>
                              </template>
                          </el-table-column>
                          <el-table-column label="备注" min-width="180">
                              <template slot-scope="scope">
                                  <p class="textHiden left" :title="scope.row.memo">{{scope.row.memo ||'--'}}</p>
                              </template>
                          </el-table-column>
                          <template slot="empty">
                            <div class="noData"><span>暂无数据</span></div>
                          </template>
                      </el-table>
                    </div>
                    </el-tab-pane>
                    <el-tab-pane label="销售单信息"  name="salesOrderInfo" v-if="ElementControls('jinshizun')==1&&cardsType == '礼品券卡'">
                      <!--S 下单人查看到的销售单信息-->
                      <el-table
                        :data="allOrderData"
                        ref="orderTable"
                        class="orderTable comTable"
                        border
                        :maxHeight="tableHeight">
                        <el-table-column type="index" label="序号" fixed></el-table-column>
                        <el-table-column label="销售单号" prop="saleorderno" sortable fixed min-width="260">
                          <template slot-scope="scope">
                            <p>
                              <el-tag
                                :type="scope.row.ordertype==0?'primary':scope.row.ordertype==1?'warning':'danger'"
                                plain
                                :title="scope.row.ordertype==0?'常规销售单':scope.row.ordertype==1?'门店分销单':'会员分销单'"
                              >{{scope.row.ordertype | saleodtypeFilter}}</el-tag>
                            </p>
                            <p :title="scope.row.saleorderno">{{scope.row.saleorderno}}</p>
                            <small
                              :title="scope.row.submitdate | dateFormate(1)"
                            >下单时间：{{scope.row.submitdate | dateFormate(1)}}</small>
                          </template>
                        </el-table-column>
                        <el-table-column label="订单/付款状态" prop="ordstate" sortable min-width="200">
                          <template slot-scope="scope">
                            <span
                              :class="scope.row.ordstate | ordstateColorFilter"
                            >{{scope.row.ordstate | saleOrderStateFilter}}</span>
                            /
                            <i
                              :class="scope.row.paystatus | orderPayStateColorFilter"
                            >{{scope.row.paystatus | saleOrderPayStateFilter}}</i>
                          </template>
                        </el-table-column>
                        <el-table-column label="发货申请/退货状态" prop="ordstate" sortable min-width="200">
                          <template slot-scope="scope">
                            <span
                              :class="scope.row.deilverapplystatus | deilverapplyColorFilter"
                            >{{scope.row.deilverapplystatus | deilverapplystatus}}</span>
                            /
                            <i
                              :class="scope.row.returnstatus | returnstatusColorFilter"
                            >{{scope.row.returnstatus | returnstatusFilter}}</i>
                          </template>
                        </el-table-column>
                        <el-table-column label="销售单内容" prop="orderPrice" min-width="350">
                          <template slot-scope="scope">
                            <section class="pdr70">
                              <div class="greyColor textFl" :title="scope.row.ordcontent">{{scope.row.ordcontent}}</div>
                              <p class="orderContentI">
                                <em class="priceFont" v-if="userInfo.flowcode==orderucode">
                                  <em>￥</em>
                                  {{scope.row.allamount | formatAmount}}
                                </em>
                                <!--商品类型-->
                                <i v-if="scope.row.goodstype==0" class="iconsw" title="实物商品"></i>
                                <i v-if="scope.row.goodstype==1" class="iconcard" title="礼品券卡"></i>
                              </p>
                            </section>
                          </template>
                        </el-table-column>
                         <el-table-column label="所属门店" min-width="250" v-if="!(userInfo.flowcode==orderucode)">
                          <template slot-scope="scope">
                            <p class="textFl" :title="scope.row.orderuname">{{scope.row.orderuname||'--'}}</p>
                          </template>
                        </el-table-column>
                        <el-table-column label="下单人" min-width="250" v-if="!(userInfo.flowcode==orderucode)">
                          <template slot-scope="scope">
                            <p class="textFl" :title="scope.row.corderuname">{{scope.row.corderuname||'--'}}</p>
                          </template>
                        </el-table-column>
                        <el-table-column label="门店支付金额(￥)" prop="storepayamount" min-width="200" v-if="userInfo.flowcode==orderucode">
                          <template slot-scope="scope">
                            <span
                              class="priceFont"
                              :title="scope.row.storepayamount | formatAmount"
                            >{{scope.row.storepayamount | formatAmount}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="消费者支付金额(￥)" prop="consumerpaystatus" sortable min-width="200" v-if="userInfo.flowcode==orderucode">
                          <template slot-scope="scope">
                            <p :class="scope.row.consumerpaystatus | consumerPayStateColorFilter"
                          >{{scope.row.consumerpaystatus | saleOrderConsumerPayStateFilter}}</p>
                            <div class="creditIcon">
                              <em :title="`已支付${$options.filters.formatAmount(scope.row.conactpaidamount)}元`"><strong>{{scope.row.conactpaidamount | formatAmount}}</strong><i class="remainIcon">已</i></em>
                              <em :title="`需支付${$options.filters.formatAmount(scope.row.conactpayamount)}元`"><strong>{{scope.row.conactpayamount | formatAmount}}</strong><i class="totalIcon">总</i></em>
                            </div> 
                          </template>
                        </el-table-column>
                        <el-table-column label="已绑会员" prop="nickname" min-width="220" v-if="userInfo.flowcode==orderucode">
                          <template slot-scope="scope">
                            <p class="textFl pdr70" :title="scope.row.nickname || '匿名会员'">{{scope.row.nickname | empty('匿名会员')}}</p>
                          </template>
                        </el-table-column>
                        <el-table-column label="销售渠道" prop="salechannelname" min-width="220" v-if="userInfo.flowcode==orderucode">
                          <template slot-scope="scope">
                            <p class="textFl pdr70" :title="scope.row.salechannelname">{{scope.row.salechannelname?scope.row.salechannelname:'--'}}</p>
                          </template>
                        </el-table-column>
                        <el-table-column label="下单备注" prop="subordmemo" min-width="250" v-if="userInfo.flowcode==orderucode">
                          <template slot-scope="scope">
                            <small class="textFl" :title="scope.row.corderuname">{{scope.row.corderuname}}</small>
                            <p
                              class="textFl pdr70"
                              :title="scope.row.subordmemo | empty"
                            >{{scope.row.subordmemo | empty}}</p>
                          </template>
                        </el-table-column>
                        <el-table-column label="面单打印备注" prop="printmemo" min-width="250" v-if="userInfo.flowcode==orderucode">
                          <template slot-scope="scope">
                            <p
                              class="textFl pdr70"
                              :title="scope.row.printmemo | empty"
                            >{{scope.row.printmemo | empty}}</p>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="60" v-if="userInfo.flowcode==orderucode">
                          <template slot-scope="scope">
                            <p class="handle">
                              <span title="详情" @click="watchDetail(scope.row)">
                                <i class="icondetails"></i>
                              </span>
                            </p>
                          </template>
                        </el-table-column>
                        <template slot="empty">
                          <div class="noData">
                            <span>暂无数据</span>
                          </div>
                        </template>
                      </el-table>
                      <!--E 下单人查看到的销售单信息-->
                    </el-tab-pane>
                    <el-tab-pane v-if="cardsType == '礼品券卡'" label="订单信息" name="cardOrderMsg">
                        <OrderInformation  :isselfCard="isselfCard" :orderinfoDetaillist="orderinfoDetaillist" :modHeight="tableHeight"></OrderInformation>
                    </el-tab-pane>
                    <el-tab-pane v-if="cardsType == '礼品券卡'" label="快递信息" name="cardDelivery">
                        <ExpressInformation :isselfCard="isselfCard" :orderinfoDetaillists="orderinfoDetaillists" :modHeight="tableHeight"></ExpressInformation>  
                    </el-tab-pane>
                </el-tabs>
            </section>
        </article>
        <!-- S 查看门店 -->
        <StoreCheck  :code="isallcode" :storeCheckDialogVisible="storeCheckDialogVisible" @closeChild="getCheckStoreCld"></StoreCheck>
        <!-- E 查看门店 -->

        <!--S 销售单详情弹窗-->
        <el-dialog
          :visible.sync="salesOdBox"
          class="comDlog shipmentBox"
          append-to-body
          :close-on-click-modal="false" 
        >
          <div slot="title" class="dialog-title">销售单详情</div>
          <SalesOdDetail :saleorderno="saleorderno" :freshGo="2"></SalesOdDetail>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeSaleOdShow">关闭</el-button>
          </span>
        </el-dialog>
        <!--E 销售单详情弹窗-->


        <!--S 老卡验真弹窗-->
      <el-dialog class="comDlog oldCardDlog" title="老卡验真" :visible.sync="showOldCardInfo" :close-on-click-modal="false" :before-close="closeOldTrue" append-to-body>
        <el-form ref="oldCheckForm" :model="checkForm" :rules="checkrules" label-width="160px" class="checkTrueForm">
          <el-form-item label="券卡编码" prop="code">
            <el-input v-model.trim="checkForm.code" ref="codeipt" maxlength="20" clearable placeholder="请输入券卡编码" @blur="hideResult"></el-input>
          </el-form-item>
          <el-form-item label="券卡密码" prop="pwd">
            <el-input v-model.trim="checkForm.pwd" maxlength="6" clearable placeholder="请输入券卡密码" @blur="hideResult"></el-input>
          </el-form-item>
          <el-form-item label="验证结果" v-if="showResult"><span :class="['fwbold',codeTrueMsg?'greenColor':'redColor']">券卡【{{resultcode}}】为{{codeTrueMsg?'真':'假'}}</span></el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="getcodebetrue()">真伪验证</el-button>
          <el-button @click="closeOldTrue(0)">重置</el-button>
        </span>
      </el-dialog>
      <!--E 老卡验真弹窗-->
      <el-dialog class="comDlog oldCardDlogold" title="券卡查询" :visible.sync="showinfocard" :close-on-click-modal="false"
      :before-close="closeinfocard" append-to-body>
      <el-table ref="gsTable" class="comTable totalTable" border :data="codelistcode">
        <el-table-column fixed label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="券面序列号" min-width="100">
          <template slot-scope="scope">
            <span class="greyColor">{{code || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="提货序列号" min-width="100">
          <template slot-scope="scope">
            <span class="greyColor">{{scope.row.serial || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="提货编码" min-width="160">
          <template slot-scope="scope">
            <span class="greyColor">{{scope.row.code || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="印刷年份" min-width="100">
          <template slot-scope="scope">
            <span class="greyColor">{{
              scope.row.index?'2024年新卡':'2016年旧卡'
              }}</span>
          </template>
        </el-table-column>
        <el-table-column label="券卡状态" min-width="100">
          <template slot-scope="scope">
            <span class="greyColor">{{scope.row.state | cardStateFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="默认商品" min-width="180">
          <template slot-scope="scope">
            <span class="greyColor">{{scope.row.defaultgoodsname || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" min-width="100">
          <template slot-scope="scope">
            <p class="serial" v-if="scope.row.startvaldate || scope.row.endvaldate">
              {{dateTime(scope.row.startvaldate)}}
              <em>~</em>
              {{dateTime(scope.row.endvaldate)}}
            </p>
            <p class="serial" v-else>
              --
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <p class="handle">
              <a v-show="scope.row.code" @click="getCoverDetailShow(scope.row)" class="icondetails" title="详细"></a>
            </p>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeinfocard">关闭</el-button>
      </span>
    </el-dialog>
    </div>
</template>

<script>
import Api from "@/apis/api.js";
import { mapState, mapActions } from "vuex";
export default {
    name:"SearchIndex",
    components: {
        ExpressInformation: resolve =>require(["@/components/common/ExpressInformation.vue"], resolve),
        OrderInformation: resolve =>require(["@/components/common/OrderInformation.vue"], resolve), //查看门店
        StoreCheck: resolve =>require(["@/components/CardsFolder/StoreCheck.vue"], resolve), //查看门店
        Page: resolve => require(["@/components/common/Page.vue"], resolve),//分页
        CardsDetail: resolve => require(["@/components/common/CardsDetail.vue"], resolve), //券卡基础信息组件
        SalesOdDetail: resolve => require(["@/components/OrderFolder/StoreSale/SalesOdDetail.vue"], resolve), //销售单详情基本信息
    },
    data(){
        return{
            isSearchAll:false,
            isallcode:'',
            isall:0,
            saleorderno:'',
            orderucode:'',
            isselfCard:false,
            infoszhanghu:'',
            infos:'',
					  vloading:false,
            activeName:'cardMessage',//选中的tab
            // ----------------------- S 券卡信息 ------------------------
            codeinfo: '', // 礼品券卡、消费卡信息
            codeInfo:'',
            couponinfo:'', // 优惠券
            code:'',//券卡编码
            cardsType:'',// 礼品券卡、优惠券、消费卡
            outActive:'basicMsg', //券卡详情-默认选择基础信息
            storeCheckDialogVisible:false,//门店选择弹框
            // ----------------------- E 券卡信息 ------------------------
            // ----------------------- S 券卡操作记录 ------------------------
            codetype:'', //编码类型
            recordinfoList:[],
            tableHeight: window.innerHeight*.8, //表格动态高度
            orderTableHeight: window.innerHeight*.8, //订单信息表格动态高度
            dlyTableHeight: window.innerHeight*.8, //快递信息表格动态高度
            // ----------------------- E 券卡操作记录 ------------------------
            salesOdBox:false,//销售单详情
            orderno:'',
            allOrderData:[],
            // ----------------------- S 订单信息 ------------------------
            orderno:'', //母单号
            childOrders:[], //子单列表
            orderinfoDetaillist:[], //母单信息
            orderinfoDetaillists:[], //母单信息快递
            ordernochild: '', // 订单号传参
            relcardsList:[], // 关联券卡列表
            orderDetailShow:false, //订单详情
            orderRelatedDialogVisible:false,//订单关联券卡弹窗
            // ----------------------- E 订单信息 ------------------------
            // ----------------------- S 订单关联券卡 ------------------------
            orderRelatedForm:{
                orderno:''//订单号
            },
            cardsMsgDialogVisible:false,//券卡详情弹框
            // ----------------------- E 订单关联券卡 ------------------------
            deliveryDetailShow:false, //快递详情
            allExpinfoList:[], //快递列表
            expcode:'', //快递
            orderAmountBox:false, //快递编辑
            editExpinfo:{}, //快递编辑传参
            showProof:true,
            checkForm:{
            code:'',//卡号
            pwd:'',//卡密
          },
          operateIndex:0,//0:查询；1：老卡验真
          showOldCardInfo:false,//老卡验真表单
          resultcode:'',//验证的券卡
          showResult:false,//验证结果
          codeTrueMsg:'',//真假状态
          checkrules:{
            code:[
              { required: true, message: '请输入券卡编码', trigger: 'blur' },
              { max: 20, message: '券卡编码最多20位', trigger: 'blur' }
            ],
            pwd:[
              { required: true, message: '请输入券卡密码', trigger: 'blur' },
              { max: 6, message: '券卡密码最多6位', trigger: 'blur' }
            ],//卡包商户名称 
          },
          codelistcode:[],
          showinfocard:false,
        }
    },
    props:{
      modHeightAll:{
        default:'',
      },//快捷查询时的列表高度
    },
    //监听
    watch: {
      "checkForm.code": function(val, oldval){
        if(val!=oldval && oldval){
          this.checkForm.pwd = '';
        }
      },
      //快捷查询
      modHeightAll:{
        handler(newval,oldval){
          if(newval){
            this.tableHeight = newval;
          }
        },
        deep: true
      },
      code(val, oldval){
        this.code= this.code.replace(/\s+/g,"")
      },
      activeName(){
          console.log(this.activeName)
          // //券卡操作记录
          // let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
          // this.tableHeight = window.innerHeight - tbHeight - 230;
          //券卡操作记录
          if(this.activeName == 'cardRecord'){
              setTimeout(()=>{
                  this.getHeight();
              },200);
          }
          //销售单信息
          if(this.activeName == 'salesOrderInfo'){
              setTimeout(()=>{
                  this.getHeight();
              },200);
          }
          //订单信息
          if(this.activeName == 'cardOrderMsg'){
              setTimeout(()=>{
                  this.getHeight();
              },200);
          }
          //快递信息
          if(this.activeName == 'cardDelivery'){
              setTimeout(()=>{
                  this.getHeight();
              },200);
          }
      }
    },
    filters:{
      // 销售订单状态颜色
      ordstateColorFilter: function(ordstate) {
        return [
          { orangeColor: ordstate == 0 || ordstate == 6 },
          { greenColor: ordstate == 1 || ordstate == 2 || ordstate == 7 },
          { redColor: ordstate ==  8},
          { greyColor: ordstate == 5 }
        ];
      },
      //申请发货状态颜色
      deilverapplyColorFilter:function(deilverapplystatus) {
        return [
          { orangeColor: deilverapplystatus == 0 || deilverapplystatus == 1 },
          { blueColor: deilverapplystatus ==  2},
        ];
      },   
      //退货状态颜色   
      returnstatusColorFilter:function(returnstatus) {
        return [
          { greenColor: returnstatus == 0},
          { orangeColor: returnstatus == 1 },
          { redColor: returnstatus ==  2},
        ];
      },
      // 销售单付款状态样色
      orderPayStateColorFilter: function(paystatus) {
        return [
          { orangeColor: paystatus == 0 },
          { blueColor: paystatus == 1 },
          { redColor: paystatus == 2 || paystatus == 3 },
          { greyColor: paystatus == 4 }
        ];
      },
      // 消费者付款状态样色
    consumerPayStateColorFilter: function(paystatus) {
      return [
        { orangeColor: paystatus == 0 || paystatus == 4 },
        { blueColor: paystatus == 1 },
        { greyColor: paystatus == 5 },
      ];
    },
      saleodtypeFilter(val) {
        if (val == 0) {
          return "常规销售单";
        } else if (val == 1) {
          return "门店分销单";
        } else {
          return "会员分销单";
        }
      }
    },
    // ================================== 方法 ==============================
    methods:{
      closeinfocard(){
          this.showinfocard = false
        },
        getCoverDetailShow(itrem){
          this.code = itrem.code
          this.showinfocard = false
          this.getcodeinfoDet()
        },
        // 券卡查询接口
        getcodeinfoDet(){
          this.allOrderData =[];
          this.operateIndex = 0;
          this.codeinfo = '';
          this.couponinfo = '';
          this.cardsType = '';
          this.activeName='cardMessage';
          if (/[\u4E00-\u9FA5]/g.test(this.code)) {
           this.$message.error('请不要输入中文！');
           this.code = '';
           return
          }
          let code = this.code.replace(/\s+/g,''); //去掉空格
          if(code==''){
            this.$message.error('编码不能为空！');
            return
          }
          if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!='null'){
            let qydm =  JSON.parse(localStorage.getItem('userInfoMd')).qydm
              if(qydm==4816){
                this.codelistcode = []
                let startcode = '00058001';
                let endcode  = '00202000';
                if(Number(startcode)<= Number(this.code) && Number(this.code)<=Number(endcode)){
                  Api.GET_CARDINFODET({code:this.code}).then(res=>{
                     if(res.data.status=='200'&&res.data.data){
                      let codeinfo = res.data.data.codeinfo
                      codeinfo.index =1
                      this.codelistcode.push(codeinfo)
                     }else{
                      this.codelistcode.push({serial:this.code,state:88,index:1})
                     }
                  })
                  let codeold = this.code.replace('0', '8')
                  Api.GET_CARDINFODET({code:codeold}).then(res=>{
                    if(res.data.status=='200'&&res.data.data){
                      let codeinfoold = res.data.data.codeinfo
                      codeinfoold.index =0
                      this.codelistcode.push(codeinfoold)
                     }else{
                      this.codelistcode.push({serial:codeold,state:88,index:0 })
                     }
                  })
                  this.showinfocard = true
                  return true
                }
              }
          }
					this.vloading = true
          Api.GET_CARDINFODET({code:code}).then(res=>{
            this.vloading = false
            this.infos ='';
            if(res.data.status=="200"){
               this.isallcode = code;
               this.code = '';
              if(res.data.data.codeinfo){ // 礼品券卡/消费卡信息
                this.codeinfo = res.data.data.codeinfo;
                this.couponinfo = '';
                 if(this.ElementControls('jinshizun')==1&&this.codeinfo.cardorderno!=null&&this.codeinfo.cardorderno!=''){
                        Api.GET_SALEORDERDETAIL({saleorderno:this.codeinfo.cardorderno}).then(res =>{
                           if(res.data.status=="200"&&res.data.data!=null){
                             this.allOrderData =[];
                             this.allOrderData.push(res.data.data);
                              this.orderucode = res.data.data.orderucode
                           }else{
                             this.orderucode =''
                             this.allOrderData = []
                           }
                        })
                    }
                if(this.codeinfo.codetype==0){ // 礼品券卡
                    this.cardsType = '礼品券卡';
                    this.codetype = 0;
                    if(localStorage.getItem('userInfoMd')){
                    let userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'))
                    let flowcode = userInfoMd.flowcode;
                    let pflowcode = userInfoMd.pflowcode;
                    let objtype = userInfoMd.objtype;
                    if(flowcode==this.codeinfo.flowcode||(objtype==6&&pflowcode==this.codeinfo.flowcode)){ //门店、店员
                        this.isselfCard = true;
                    }else{
                        this.isselfCard = false;
                    }
                  }
                }else if(this.codeinfo.codetype==1){ // 消费卡信息
                    this.cardsType = '消费卡';
                    this.codetype = 2;
                    if(this.codeinfo.rechargeInfo){
                       this.infoszhanghu = this.codeinfo.rechargeInfo;
                    }else{
                       this.infoszhanghu = '';
                    }
                    if(this.codeinfo.cardBagInfo){
                       this.infos = this.codeinfo.cardBagInfo;
                    }else{
                       this.infos = '';
                    }
                }
              }else if(res.data.data.couponinfo){ // 优惠券
                this.cardsType = '优惠券';
                this.codetype = 1;
                this.couponinfo = res.data.data.couponinfo;
                this.codeinfo = '';
                if(this.couponinfo.cardBagInfo){
                  this.infos = this.couponinfo.cardBagInfo;
                }else{
                  this.infos = '';
                }
              }else {
                this.codeinfo = '';
                this.couponinfo = '';
                this.cardsType = '';
                this.infos ='';
              }
              this.getRecordinfoList(code); // 操作接口
              if((this.codeinfo!=''&&this.codeinfo.codetype=='0')||this.couponinfo!=''){
                  this.getRelOrdernos(code) //获取母单号 （订单信息）
              }
            }else{
                this.$refs.refcode.focus();
                this.$message.error(res.data.message);
                this.codeinfo = '';
                this.code ='';
                this.couponinfo = '';
                this.cardsType = '';
             }
          })
        },
        //老卡验真
        async showCodeForm(){
          this.operateIndex = 1;
          // if (/[\u4E00-\u9FA5]/g.test(this.code)) {
          //  this.$message.error('请不要输入中文！');
          //  this.code = '';
          //  return
          // }
          // let code = this.code.replace(/\s+/g,''); //去掉空格
          // if(code==''){
          //   this.$message.error('券卡编码不能为空！');
          //   return
          // }
          this.resultcode = this.code;
          this.checkForm.code = this.code;
          await (()=>{
            this.code = '';
          })()
          this.showOldCardInfo = true;
          this.$nextTick(() => {
            this.$refs.oldCheckForm.clearValidate();
          })
        },
        //真伪验证
        getcodebetrue(){ 
          if (/[\u4E00-\u9FA5]/g.test(this.checkForm.code)) {
           this.$message.error('请不要输入中文！');
           this.checkForm.code = '';
           return
          }
          let code = this.checkForm.code.replace(/\s+/g,''); //去掉空格
          if(code==''){
            this.$message.error('券卡编码不能为空！');
            return
          }
          if(code.length!=16){
             this.$message.error('请输入16位的编码！');
            return
          }
          if (/[\u4E00-\u9FA5]/g.test(this.checkForm.pwd)) {
           this.$message.error('请不要输入中文！');
           this.checkForm.pwd = '';
           return
          }
          let pwd = this.checkForm.pwd.replace(/\s+/g,''); //去掉空格
          if(pwd==''){
            this.$message.error('券卡密码不能为空！');
            return
          }
          Api.CHECKCARDBETRUE({code:code,pwd:pwd}).then(res=>{
            this.resultcode = code;
            if(res.data.status=="200"){ 
              this.codeTrueMsg = res.data.data;
              this.showResult = true;
              this.checkForm.code = '';
              this.checkForm.pwd = '';
              this.$nextTick(() => {
                this.$refs.oldCheckForm.clearValidate();
              })
            }else{
              this.$message.error(res.data.message);
            }
            this.$refs.codeipt.focus();
          })
          
        },
        //关闭验真弹窗
        closeOldTrue(val){
          if(val==0){
            //重置操作
          }else {
            this.showOldCardInfo = false;
          }
          this.checkForm.code = '';
          this.checkForm.pwd = '';
          this.showResult = false;
          this.$refs.refcode.focus();
        },
        //验真结束
        hideResult(){
          if((this.checkForm.code && this.checkForm.code!=this.resultcode) || (this.checkForm.pwd && this.checkForm.code!=this.resultcode)){
            this.showResult = false;
          }
        },
        isallList(){
          if(this.isSearchAll){
             this.isall =1;
          }else{
            this.isall =0;
          }
          this.getRecordinfoList(this.isallcode)
        },
        // 操作记录
        getRecordinfoList(code){
          Api.GET_RECORDINFOLIST({code:code,codetype:this.codetype,isall:this.isall}).then(res=>{
              if(res.data.status=="200"&&res.data.data!=null){
                  this.recordinfoList = res.data.data;
              }else{
                 this.recordinfoList = [];
              }
          })
        },
        // 获取母单号
        getRelOrdernos(code){
           this.orderinfoDetaillist =[];
           this.orderinfoDetaillists =[];
           Api.GET_RELORDERNOS({code:code}).then(res =>{
               if(res.data.status=="200"&&res.data.data!=null){
                  this.orderno = res.data.data;
                   this.orderlist();
                   this.orderslist();
               }else{
                 this.orderinfoDetaillist =[];
                 this.orderinfoDetaillists =[];
               }
           })
        },
        orderslist(){
          if(this.orderno.length>0){
                this.orderinfoDetaillist =[];
                this.orderno.map((item,index)=>{
                Api.GET_ORDERINFODETAIL({orderno:item}).then(res=>{
                  if(res.data.status=="200"&&res.data.data!=null){
                    this.orderinfoDetaillist.push(res.data.data);
                  }
                })
              })
            }
            setTimeout(()=>{
                  this.orderinfoDetaillist.sort((a, b)=>{
                    let date1 =  new Date(a.submitdate.replace(/-/g, '/'));
                    let date2 =  new Date(b.submitdate.replace(/-/g, '/'));
                    let as = date1.getTime()
                    let bs = date2.getTime()
                    return bs-as;
                  })
            },300)
        },
        orderlist(){
          if(this.orderno.length>0){
            Api.GET_ALLEXPINFOLIST({ordernos:String(this.orderno),isShowByOrder:1}).then(res =>{
                    if(res.data.status=="200"&&res.data.data!=null){
                      this.orderinfoDetaillists =res.data.data;
                  }
                })
          }
        },
        // 打开查看门店弹窗
        getShowCheckStore() {
            this.storeCheckDialogVisible = true;
        },
        // 关闭查看门店弹窗
        getCheckStoreCld() {
            this.storeCheckDialogVisible = false;
        },
        //打开销售单详情弹窗
        watchDetail(row){
          this.saleorderno = row.saleorderno;
          if(this.saleorderno){
            this.salesOdBox = true;
          }
        },
        //关闭销售单详情弹窗
        closeSaleOdShow() {
          this.salesOdBox = false;
        },
        //动态获取表格高度
        getHeight() {
          if(this.$refs.gsTable){
            if(this.modHeightAll){
              this.tableHeight = this.modHeightAll
            }else{
              let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
              this.tableHeight = window.innerHeight - tbHeight - 230; 
            }
          }
        },
    },
    // ==================================== 生命周期 ====================================
    mounted () {
      	if(localStorage.getItem('userInfoMd')&&localStorage.getItem('userInfoMd')!='null'){
				 this.userInfo = 	JSON.parse(localStorage.getItem('userInfoMd'))
			   }
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
        this.$nextTick(() => {
           this.$refs.refcode.focus();
        })
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        exptypes: ({ common }) => common.exptypes,
      })
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
};
</script>

<style scoped>
.cardArticle{
  padding: 20px;
  /* margin-top: 80px; */
}
.cardSearsh .el-form {font-size: 0;} 
.cardSearsh{
  margin:20px 0 0 20px;
  height:60px;
  background: #DCDFE6;
  line-height:60px;
  padding:0 10px;
  position:relative;
  z-index:19;
  width:830px;
}
.quickSearch .cardSearsh{ width: 50%; min-width:600px;}
/* .helpRight .cardSearsh{
  width: calc(100% - 500px);
} */
.cardSearsh .el-input{
 /* width:88%; */
  flex: 1;
}
.cardSearsh em{
  display:inline-block;
  /* width:calc(12% - 10px); */
  font-weight: bold;
  margin: 0 10px;
  font-size: 16px;
  line-height:60px;
  cursor: pointer;
  min-width: 60px;
  text-align: center;
  white-space: nowrap;
  vertical-align: top;
}
.cardSearsh em.on {color:var(--main-color)}
/* --------------- S 券卡信息 -------------------- */
/* S 出库详情弹框-基础信息 */
.basicWrap ul{
    width: 50%;
    padding-left: 40px;
}
.basicWrap ul li{
    margin: 20px 0;
}
.basicWrap ul li:first-child{
    margin-top: 10px;
}
.basicWrap ul li em{
    color: #333;
    width: 100px;
    display: inline-block;
    text-align: right;
    min-width:100px;
}
.basicWrap ul li b{
    color: #999;
}
.basicWrap ul li b.priceFont{
    color: #333;
}
.basicWrap ul li .black{
    color: #333;
    margin-right: 5px;
}
.rulrMemo{display: -webkit-flex; display: flex;}
.rulrMemo b{
    width: calc(100% - 100px);
}
.rulrMemo b span{color:#999; display:block;padding-bottom:10px;margin-left: 5px;} 
.rulrMemo b span i {display:block; padding-bottom:10px; margin-left: 0!important;}
.basicWrap strong{
    color: #F2962C;
    font-weight: bold;
    margin-left: 10px;
}
.basicWrap .boldStr{
  margin-left:0;
}
.basicWrap i{
    font-size: 16px;
    color: #F2962C;
    margin-left: 5px;
}
/* E 出库详情弹框-基础信息 */
/* S 出库详情弹框-券卡规则 */
.zoneTable{
    font-size: 12px;
    border: none;
    border-top: 1px solid #EBEEF5;
}
.zoneTable::before{
    height: 0;
}
.zoneTable thead{
    display: none;
}
.zoneTable tbody tr:last-child td{
    border-bottom: none;
}
.zoneAvatar{
    border: 1px solid #EBEEF5;
    width: 90px;
    height: 90px;
    position: relative;
}
.zoneInfo em{
    font-size: 12px;
    display: block;
}
.zoneInfo p{
    color: #666; 
}
.zoneInfo strong{
    font-weight: bold;
    color: #333;
    margin-left: 0;
    font-size: 16px;
}
.zoneInfo strong i{
    font-size: 14px;
    font-weight: normal;
    color: #666;
    margin-left: 0;
}
.zoneInfo strong span{
    font-size: 12px;
    font-weight: normal;
}
.zoneDate{
    color: #666;
}
.zoneDate em{
    display: block;
    text-align: center;
}
.ruleWrap{
    margin-bottom: 0;
}
.ruleWrap ul{
    width: 40%;
}
.ruleWrap .ruleTab{
    width: 60%;
    box-shadow: none;
}
.ruleTab .el-tabs__nav{
    height: 40px;
}
.ruleTab .el-tabs__item{
    color: #333!important;
    font-weight: bold!important;
    width: 130px;
    text-align: center;
    height: 100%;
    border-right: 1px solid #E8EAED!important;
}
.ruleTab .el-tabs__item:last-child{
    border-right: none!important;
}
.ruleTab .el-tabs__content{
    padding: 10px 0 0 0!important;
}
.ruleTab.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
    height:41px;
}
.goodsNum{
    height: 50px;
    width: 100%;
    padding: 0 10px;
    background: #F5F7FA;
    line-height: 50px;
    color: #333;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.goodsNum b{
    color: #F7615E;
    font-weight: bold;
    font-size: 18px;
    margin: 0 6px;
}
.goodsNum i{
    color: #999;
    margin: 0;
}
.ruleWrap b i{
    color: #333;
    margin-left: 0;
    margin-right: 5px;
}
.ruleWrap b .moneyIcon{
    margin-right: 0;
    font-size: 14px;
    font-weight: normal;
}
.checkStore{
    cursor: pointer;
}
/* E 出库详情弹框-券卡规则 */
/* --------------- E 券卡信息 -------------------- */
.recordTable th:last-child .cell, .recordTable td:last-child .cell, .recordTable th:first-child .cell, .recordTable td:first-child .cell{
  text-align: center;
}
.cardsTab{margin-top:5px;}
/* --------------- S 订单信息 -------------------- */
.orderTable {position: relative; height: 100%;}
.orderTable small {display:block; color:#999;}
.orderTable .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.priceFont em{font-size: 14px; font-weight: 400;}
.shouMsg strong{border: 1px solid #3c9bfa; border-radius: 10px;padding: 0 6px; font-weight: bold;}
.shouMsg strong.blueColor {border-color:#3c9bfa;}
.shouMsg strong.orangeColor {border-color:#FF7018;}
.orderContentI i{font-size: 18px;}
.haveChildOd p {line-height:18px;}
.haveChildOd .iconadd2 {font-size: 18px; color:var(--main-color);vertical-align: top; cursor: pointer}
.dateSource{
  line-height: 25px;
}
.dateSource small{
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 50px);
}
.dateSource strong{
  font-weight: bold;
}
.CheckBold{
  font-weight:bold;
  color:#333;
  cursor:pointer;
}
.deliveryNum i{
  color:#999;
  margin-left:5px;
}
.goodsDlog .el-dialog{
    width: 1120px;
}
/* --------------- E 订单信息 -------------------- */
/* S 会员信息 */
.bannerBg{background: #f5f5f5;padding: 15px 20px;margin-bottom:20px;width: 40%;}
.bannerBg .bannerTit{color: #333;}
.bannerBg .bannerTit b{font-weight: bold;}
.bannerBg ul{width: 100%!important;padding-left: 20px;}
.bannerBg ul li{margin-bottom: 0!important;}
.bannerBg .realname{max-width: calc(100% - 70px);display: inline-block;vertical-align: top;color: #333;;width: auto;}
.avatarImg{width: 90px;text-align: right;padding-right: 10px;}
.avatarImg samp{position: relative;width: 50px;height: 50px;display: inline-block;border-radius: 50%;border: solid 1px #dcdfe6;}
.avatarImg img{border-radius: 50%;}
.memberInfo{width: 100%;}
.memberInfo p{width: calc(100% - 200px);padding-right: 70px;}
.memberInfo p strong{color: #666;margin-left: 0;display: inline-block;font-weight: normal;margin-bottom: 5px;max-width: 50%;width: auto;vertical-align: top;}
.memberInfo p b{max-width: 48%;width: auto;vertical-align: top;display: inline-block;}
.memberInfo p span{display: block;}
/* E 会员信息 */
.basicWrap ul li b i{color: #999;}
/*S 销售单信息*/
.creditIcon em{
    display: block;
    color: #333;
    font-size: 14px;
    margin: 5px 0;
}
.creditIcon em i{
    display: inline-block;
    height: 20px;
    width: 20px;
    color: #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 5px;
}
.creditIcon em .remainIcon{
    background: #f56262;
}
.creditIcon em .usedIcon{
    background: #f2962c;
}
.creditIcon em .totalIcon{
    background: var(--main-color);
}
.creditIcon em strong{
    min-width: 80px;
    text-align: left;
    display: inline-block;
    font-weight: 700;
}
.pdr70{
    padding-right: 70px;
    width: auto;
}
/*E 销售单信息*/
/* 查询全部 */
.individualiz>>>form{padding-top: 10px!important;}

/*销售单详情弹窗 start*/
.shipmentBox >>> .el-dialog {
  width:80%;
  min-width: 1230px;
}
.shipmentBox >>> .el-dialog__body {max-height: 577px;}
/*销售单详情弹窗 end*/

/*老卡验真弹窗 start */
.oldCardDlog>>>.el-dialog {width:650px;}
.fwbold {font-size: 16px;font-weight: 600;}
.checkTrueForm {margin-top:70px;}
.checkTrueForm >>> .el-form-item:not(.allWidth) .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.checkTrueForm >>> .el-form-item__content .el-input {width:100%;}
/*老卡验真弹窗 end */
.oldCardDlogold>>>.el-dialog {width:1300px;height: 400px;}
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsSearch/SearchIndex.vue